import Slides from './Slides.js';

import img1 from './images/portfolio/churches-schools-and-sports/001.jpg';
import img2 from './images/portfolio/churches-schools-and-sports/002.jpg';
import img3 from './images/portfolio/churches-schools-and-sports/015.jpg';
import img4 from './images/portfolio/churches-schools-and-sports/018.jpg';
import img5 from './images/portfolio/churches-schools-and-sports/028.jpg';
import img6 from './images/portfolio/churches-schools-and-sports/060.jpg';
import img7 from './images/portfolio/churches-schools-and-sports/154.jpg';
import img8 from './images/portfolio/churches-schools-and-sports/366.jpg';
import img9 from './images/portfolio/churches-schools-and-sports/ASR_IMG3409.jpg';
import img10 from './images/portfolio/churches-schools-and-sports/GroupIMG_122.jpg';
import img11 from './images/portfolio/churches-schools-and-sports/Hanley_V_IMG9057.jpg';
import img12 from './images/portfolio/churches-schools-and-sports/IMG_025.jpg';
import img13 from './images/portfolio/churches-schools-and-sports/IMG_8293.jpg';
import img14 from './images/portfolio/churches-schools-and-sports/Img0063.jpg';
import img15 from './images/portfolio/churches-schools-and-sports/Img030.jpg';
import img16 from './images/portfolio/churches-schools-and-sports/Matthew_Dochnal_IMG_013.jpg';
import img17 from './images/portfolio/churches-schools-and-sports/SLCD_Board_2010_IMG1206.jpg';
import img18 from './images/portfolio/churches-schools-and-sports/_094.jpg';
import img19 from './images/portfolio/churches-schools-and-sports/_334.jpg';
import img20 from './images/portfolio/churches-schools-and-sports/_DSC0009.jpg';
import img21 from './images/portfolio/churches-schools-and-sports/_DSC2032.jpg';
import img22 from './images/portfolio/churches-schools-and-sports/_DSC2078.jpg';
import img23 from './images/portfolio/churches-schools-and-sports/_IMG0325.jpg';
import img24 from './images/portfolio/churches-schools-and-sports/_IMG0594.jpg';
import img25 from './images/portfolio/churches-schools-and-sports/_IMG1183.jpg';
import img26 from './images/portfolio/churches-schools-and-sports/_IMG1906.jpg';
import img27 from './images/portfolio/churches-schools-and-sports/_IMG5185.jpg';
import img28 from './images/portfolio/churches-schools-and-sports/_IMG5669.jpg';
import img29 from './images/portfolio/churches-schools-and-sports/_IMG5767.jpg';
import img30 from './images/portfolio/churches-schools-and-sports/_IMG5933.jpg';
import img31 from './images/portfolio/churches-schools-and-sports/_IMG5991.jpg';
import img32 from './images/portfolio/churches-schools-and-sports/_IMG7362.jpg';
import img33 from './images/portfolio/churches-schools-and-sports/asr_IMG1750.jpg';
import img34 from './images/portfolio/churches-schools-and-sports/image_0285.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
];

function ChurchesSchoolsAndSports() {
    return <Slides images={images}/>;
}

export default ChurchesSchoolsAndSports;
